import { datadogRum } from '@datadog/browser-rum';

export const TAGGING_EVENT_ATTRIBUTE = 'data-tagging-event';
export const TAGGING_PARAMS_ATTRIBUTE = 'data-tagging-context';

function handleTaggingClick(event: MouseEvent) {
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }

    const taggedElement = target.closest(`[${TAGGING_EVENT_ATTRIBUTE}]`);
    if (!taggedElement) {
        return;
    }

    const eventName = taggedElement.getAttribute(TAGGING_EVENT_ATTRIBUTE);
    if (!eventName) {
        return;
    }

    const rawParams = taggedElement.getAttribute(TAGGING_PARAMS_ATTRIBUTE);
    let eventContext: object | undefined;
    if (rawParams) {
        try {
            eventContext = JSON.parse(rawParams);
        } catch (error) {
            console.error(`Invalid JSON in ${TAGGING_PARAMS_ATTRIBUTE}`, error);
        }
    }

    sendEvent(eventName, eventContext);
}

export function initTaggingListener(): () => void {
    document.addEventListener('click', handleTaggingClick);
    return () => document.removeEventListener('click', handleTaggingClick);
}

export function sendEvent(eventName: string, eventContext?: object) {
    datadogRum.addAction(eventName, eventContext);
}
